import { CenteredFlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { StyledErrorContent, StyledErrorImage, StyledSubTitle, StyledTitle } from "./styles";

const WizardErrorContent = () => {
    return (
        <StyledErrorContent>
            <StyledErrorImage iconName="no-data-tree" />
            <CenteredFlexColumn>
                <I18n
                    element={StyledTitle}
                    translatable={{ key: "si.onboarding.error.title" }}
                />
                <I18n
                    element={StyledSubTitle}
                    translatable={{ key: "si.onboarding.error.subtitle" }}
                />
            </CenteredFlexColumn>
        </StyledErrorContent>
    );
}

export default WizardErrorContent;